import { render, staticRenderFns } from "./SalesResourcesDocu.vue?vue&type=template&id=7cdfd29c&scoped=true"
import script from "./SalesResourcesDocu.vue?vue&type=script&lang=js"
export * from "./SalesResourcesDocu.vue?vue&type=script&lang=js"
import style0 from "./SalesResourcesDocu.vue?vue&type=style&index=0&id=7cdfd29c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdfd29c",
  null
  
)

export default component.exports